import React, { FC } from 'react';
import cx from 'classnames';

import LogoSvg from 'assets/logo.svg';

import styles from './logo.module.scss';

interface IProps {
  title?: string;
  className?: string;
}

const Logo: FC<IProps> = ({
  title,
  className,
}) => (
  <LogoSvg
    role="img"
    aria-label={title || 'Coatue'}
    width="0"
    height="0"
    className={cx(styles.logo, className)}
  />
);

export default Logo;
